// Recipe URLs are free text typed by the user and stored in their own Firestore
// document, so they come back out of the database unvalidated. Vue does not
// sanitise :href bindings - a stored "javascript:..." URL would run as soon as
// the link is clicked. Anything that isn't plain http(s) is dropped.
export const safeUrl = (url) => {
  if (typeof url !== "string") return null;

  const trimmed = url.trim();
  if (!trimmed) return null;

  try {
    const parsed = new URL(trimmed);
    return parsed.protocol === "http:" || parsed.protocol === "https:"
      ? parsed.href
      : null;
  } catch {
    // Not an absolute URL (e.g. "tine.no/oppskrift") - treat it as https.
    return /^[\w.-]+\.[a-z]{2,}(\/|$)/i.test(trimmed) ? `https://${trimmed}` : null;
  }
};
